// Enum for campaign navigation sections to ensure compile-time safety
export enum NavigationSection {
    // Prep Phase
    PURPOSE = 'purpose',
    DATES = 'dates',
    APPLICATIONS = 'applications',
    COMMUNICATION = 'communication',
    LAUNCH = 'launch',

    // Matching Phase
    MATCHING_OVERVIEW = 'matching_overview',
    MENTEE_APPLICANTS = 'mentee_applicants',
    MENTOR_APPLICANTS = 'mentor_applicants',
    SCORES = 'scores',
    MATCHES = 'matches',

    // Running Phase
    RUNNING_OVERVIEW = 'running_overview',
    MATCHES_STATUS = 'matches_status',
    REMATCHING = 'rematching',

    // Follow-up Phase
    FOLLOWUP_OVERVIEW = 'followup_overview',
    FINAL_STATUS = 'final_status',
}
